<div class="flex flex-col gap-6">

  <!-- Raw buffer -->
  <div class="flex flex-col gap-3">
    <div class="text-base font-semibold text-surface-700 dark:text-surface-300">
      {{ 'measurement.dataTrace.rawBuffer' | translate }}
    </div>
    @if (channelStats().length) {
      <div class="grid gap-3" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))">
        @for (ch of channelStats(); track ch.channelKey) {
          <div class="border border-surface-200 dark:border-surface-700 rounded-border p-4">
            <div class="text-lg font-semibold text-surface-900 dark:text-surface-0">
              {{ ch.channelKey }}
            </div>
            <div class="text-base text-surface-600 dark:text-surface-400">
              {{ ch.count }} {{ 'measurement.dataTrace.datapoints' | translate }}
            </div>
            @if (ch.first && ch.last) {
              <div class="text-sm text-surface-500 dark:text-surface-400 mt-1 tabular-nums">
                {{ ch.first | date:'dd/MM/yyyy HH:mm' }} – {{ ch.last | date:'dd/MM/yyyy HH:mm' }}
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <p-message severity="info">{{ 'measurement.shm.noData' | translate }}</p-message>
    }
  </div>

  <p-divider></p-divider>

  <!-- Crop window -->
  <div class="flex flex-col gap-3">
    <div class="text-base font-semibold text-surface-700 dark:text-surface-300">
      {{ 'measurement.dataTrace.window' | translate }}
    </div>
    @if (window()?.startTs || window()?.endTs) {
      <div class="flex items-center justify-between gap-3 flex-wrap">
        <span class="text-base tabular-nums text-surface-900 dark:text-surface-0">
          {{ window()?.startTs ? (window()!.startTs | date:'dd/MM/yyyy HH:mm') : '…' }}
          –
          {{ window()?.endTs ? (window()!.endTs | date:'dd/MM/yyyy HH:mm') : '…' }}
        </span>
        <p-button
          [label]="'measurement.reschedule.window.clear' | translate"
          icon="fa-solid fa-xmark"
          [loading]="clearingWindow()"
          (onClick)="clearWindow()"
        />
      </div>
    } @else {
      <span class="text-base text-surface-600 dark:text-surface-400">
        {{ 'measurement.dataTrace.fullRange' | translate }}
      </span>
    }
  </div>

  <p-divider></p-divider>

  <!-- Removed datapoints -->
  <div class="flex flex-col gap-3">
    <div class="text-base font-semibold text-surface-700 dark:text-surface-300">
      {{ 'measurement.dataTrace.removed' | translate }} ({{ removedRows().length }})
    </div>
    @if (removedRows().length) {
      <p-table [value]="removedRows()" [scrollable]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'measurement.datapoint.variable' | translate }}</th>
            <th>{{ 'measurement.dataTrace.datapointTime' | translate }}</th>
            <th>{{ 'measurement.dataTrace.removedAt' | translate }}</th>
            @if (rbac.isProjectAdmin()) { <th></th> }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.channelKey }}</td>
            <td class="tabular-nums">{{ row.ts | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="text-sm text-surface-500 dark:text-surface-400">
              {{ row.removedAt | date:'dd/MM/yyyy HH:mm' }}
              @if (row.reason) { · {{ row.reason }} }
            </td>
            @if (rbac.isProjectAdmin()) {
              <td class="text-right">
                <p-button
                  [label]="'measurement.dataTrace.restore' | translate"
                  icon="fa-solid fa-rotate-left"
                  [loading]="isRestoring(row)"
                  (onClick)="restore(row)"
                />
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <span class="text-base text-surface-600 dark:text-surface-400">
        {{ 'measurement.dataTrace.noRemoved' | translate }}
      </span>
    }
  </div>
</div>
